import React from 'react';
import { Trans } from 'react-i18next';
import { instanceOf } from 'prop-types';

const sectionSortOrder = {
  listening: 1,
  reading: 2,
  total: 3,
  structureAndWrittenExpression: 4,
  languageFormAndMeaning: 5,
  speaking: 6,
  writing: 7,
};

const orderSections = (a, b) =>
  sectionSortOrder[a.get('translationKey')] >= sectionSortOrder[b.get('translationKey')] ? 1 : -1;

const SessionCandidateScore = ({ scoring }) => {
  const scores = scoring.get('scores');
  const moreThanThreeScores = scores.size > 3;

  return (
    <div className="account-session-candidate__score">
      {scores
        .sort(orderSections)
        .map((score, key) => {
          const translationKey = score.get('translationKey');
          const isTotal = translationKey === 'total';
          const scoreClass = isTotal ? (moreThanThreeScores ? 'total-score' : 'total-score-only') : '';
          const label = isTotal ? (moreThanThreeScores ?
              'account.sessions.candidate.total-score-listening-and-reading' : 'account.sessions.candidate.total-score') :
            `account.sessions.candidate.score.${translationKey}`;

          return (
            <div key={key} className={`account-session-candidate__score-row ${scoreClass}`}>
              <p>
                <Trans>{label}</Trans>
              </p>
              <p>
                {score.get('value') > 0 ? score.get('value') : (
                  <Trans>account.sessions.candidate.score.not_available</Trans>
                )}
              </p>
            </div>
          );
        })}
    </div>
  );
};

SessionCandidateScore.propTypes = {
  scoring: instanceOf(Object).isRequired,
};

export default SessionCandidateScore;
